import MomentUtils from '@date-io/moment';
import { Moment } from 'moment';

// Date picker calendars start the week on Monday whatever the UI language.
// MomentUtils builds the day grid from the picker's locale but the weekday
// header from the global moment locale, so with English they disagreed and
// every date sat under the wrong weekday.
class MondayMomentUtils extends MomentUtils {
  getWeekdays() {
    const days = this.moment.weekdaysShort();
    return [...days.slice(1), days[0]];
  }

  getWeekArray(date: Moment) {
    const end = date.clone().endOf('month').endOf('isoWeek');
    const weeks: Moment[][] = [];
    let current = date.clone().startOf('month').startOf('isoWeek');
    let count = 0;
    while (current.isBefore(end)) {
      const week = Math.floor(count / 7);
      weeks[week] = weeks[week] || [];
      weeks[week].push(current);
      current = current.clone().add(1, 'day');
      count += 1;
    }
    return weeks;
  }
}

export default MondayMomentUtils;
